import { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const TUPLE_CLAIM = 'https://user.waterproplan.com/enrollment_tuple';

export default function useEnrollmentTuple() {
  const { getIdTokenClaims } = useAuth0();
  const [state, setState] = useState({
    tuple: null,
    isLoading: true,
    error: null,
  });

  const refresh = useCallback(async () => {
    try {
      const claims = await getIdTokenClaims();
      const tuple =
        claims && typeof claims === 'object' ? claims[TUPLE_CLAIM] : null;
      setState({
        tuple: tuple || null,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      setState({
        tuple: null,
        isLoading: false,
        error,
      });
    }
  }, [getIdTokenClaims]);

  useEffect(() => {
    let isMounted = true;
    refresh().catch((error) => {
      if (isMounted) {
        setState({ tuple: null, isLoading: false, error });
      }
    });
    return () => {
      isMounted = false;
    };
  }, [refresh]);

  return {
    ...state,
    refresh,
  };
}
